<template>
  <v-layout row class="dabout-full-flex grey lighten-3">
    <Right/>
  </v-layout>
</template>

<script>
  import Left from './LeftAbout';
  import Right from './RightAbout';
  export default {
    components: {Left, Right},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dabout-full-flex {
    height: 100vh;
    width: 100%;
    min-width: 100%;
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/desktop/about/About.vue